export const usersDelegatedBy = async function ({ rootState }) {
  const userDetails = rootState['user-login'].user;
  let userId = userDetails.haveSwitchedToDelegate ? userDetails.originalUserID : userDetails.ID;
  try {
    if (!userId) {
      return;
    }

    const data = await this.$axios.$get(`/api/user-delegates/${userId}/users`);
    rootState.ListDelegatedToCurrentUser = data || [];
  } catch (e) {
    this.$toast.error(this.$errorFromResponse('common.delegate.users_delegated_by.fetching_list', e));
  }
};
